import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 24px;
  padding-top: 8px;
  box-sizing: border-box;
`;
